import { render, staticRenderFns } from "./shouyeEditTask.vue?vue&type=template&id=eb130f18&scoped=true"
import script from "./shouyeEditTask.vue?vue&type=script&lang=js"
export * from "./shouyeEditTask.vue?vue&type=script&lang=js"
import style0 from "./shouyeEditTask.vue?vue&type=style&index=0&id=eb130f18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb130f18",
  null
  
)

export default component.exports